module.exports = __webpack_public_path__ + "img/noDataDimension.6a763cec.png";